export const sip_account = {
  modal: {
    remove: {
      content: `Are you sure you want to delete the SIP-account <b>{name}<b>?`
    }
  },

  table: {
    field: {
      login: 'Login',
      host: 'Host',
      password: 'Password',
      internal_number_id: 'Internal number',
      caller_id: 'External number'
    }
  },

  form: {
    title: {
      edit: {
        main: 'SIP-Account data',
        in_phone: 'PBX extension number',
        out_phone: 'PBX outgoing number'
      }
    },

    field: {
      name: 'Name',
      login: 'Login',
      password: 'Password',
      host: 'Host',
      in_phone: 'Extension number',
      out_phone: 'Outgoing number',
      wrtc: 'Support webRTC'
    },

    tooltips: {
      login: 'Login is generated automatically',
      password: 'Password is generated automatically'
    }
  }
};
